/**
 * Функция склонения существительных в зависимости от числа
 * Использование: declOfNum(count, ['1 Яблоко','2 Яблока','5 Яблок']);
 * @param num
 * @param titles
 */

export const declension = (
  num: number,
  titles: [string, string, string]
): string => {
  const cases: number[] = [2, 0, 1, 1, 1, 2]

  return titles[
    num % 100 > 4 && num % 100 < 20 ? 2 : cases[num % 10 < 5 ? num % 10 : 5]
  ]
}
